import React, { useMemo } from 'react';

export default function InteractiveBackground() {
  const particles = useMemo(
    () =>
      Array.from({ length: 42 }, (_, index) => ({
        id: index,
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        delay: `${Math.random() * 4}s`,
        duration: `${6 + Math.random() * 8}s`,
      })),
    []
  );

  return (
    <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
      <div className="absolute inset-0 bg-base" />
      <div className="absolute -left-24 top-[-20%] h-[42rem] w-[42rem] rounded-full bg-cyan-500/20 blur-3xl animate-mesh" />
      <div className="absolute right-[-18%] top-[10%] h-[32rem] w-[32rem] rounded-full bg-violet-500/20 blur-3xl animate-mesh" />
      <div className="absolute bottom-[-20%] left-[18%] h-[36rem] w-[36rem] rounded-full bg-blue-500/20 blur-3xl animate-mesh" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.09),transparent_30%),radial-gradient(circle_at_80%_40%,rgba(95,85,255,0.12),transparent_35%)]" />

      {particles.map((particle) => (
        <span
          key={particle.id}
          className="particle-dot"
          style={{
            left: particle.left,
            top: particle.top,
            animationDelay: particle.delay,
            animationDuration: particle.duration,
          }}
        />
      ))}
    </div>
  );
}
